import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6ea3e253"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "faq",
  class: "com-div clearfix"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "faq-left fl"
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "toc"
})], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "faq-right fr doc-viewer"
}, null, -1));

const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4);
}